import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, MenuItem, Select, Button, Grid, OutlinedInput, InputAdornment, useMediaQuery, TextField, Autocomplete } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/modifierCaracteristique.css';

export const ModifierCaracteristique = ({ modifyCaracteristique, setModifyCaracteristique }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width:600px)');
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);

    const [brandOptions, setBrandOptions] = useState([]);

    const fetchMarques = useCallback(async () => {
        try {
            const response = await axios.get('marque');
            if (response.status === 200 || response.status === 201) {
                setBrandOptions(response.data);
            }
        } catch (error) {
            console.error('Error Fetching Marques:', error);
            CustomErrorLogger(error, 'Error Fetching Marques in machine ModifierCaracteristique');
        }
    }, []);

    useEffect(() => {
        fetchMarques();
    }, [fetchMarques]);

    const formik = useFormik({
        initialValues: {
            marque: machineDetailsData?.marque || '',
            length: machineDetailsData?.length || '',
            width: machineDetailsData?.width || '',
            height: machineDetailsData?.height || '',
            internal_codification: machineDetailsData?.internal_codification || '',
            electric_power: machineDetailsData?.electric_power || '',
            manufacture_date: machineDetailsData?.manufacture_date || '',
            commissioning_date: machineDetailsData?.commissioning_date || '',
            Dedicated_to: machineDetailsData?.Dedicated_to || '',
            model: machineDetailsData?.model || '',
            type: machineDetailsData?.type || '',
            serial_number: machineDetailsData?.serial_number || '',
            intensity: machineDetailsData?.intensity || '',
            purchase_date: machineDetailsData?.purchase_date || '',
            purchase_price: machineDetailsData?.purchase_price || '',
        },
        validationSchema: Yup.object().shape({
            marque: Yup.object().nullable(),
            length: Yup.number().nullable(),
            width: Yup.number().nullable(),
            height: Yup.number().nullable(),
            internal_codification: Yup.string().nullable(),
            electric_power: Yup.number().nullable(),
            manufacture_date: Yup.date().nullable(),
            commissioning_date: Yup.date().nullable(),
            Dedicated_to: Yup.string().nullable(),
            model: Yup.string().nullable(),
            type: Yup.string().nullable(),
            serial_number: Yup.string().nullable(),
            intensity: Yup.number().nullable(),
            purchase_date: Yup.date().nullable(),
            purchase_price: Yup.number().nullable(),
        }),
        onSubmit: async (values) => {
            const data = {
                marque_id: values.marque?.id || null,
                length: values.length ? Number(values.length) : null,
                width: values.width ? Number(values.width) : null,
                height: values.height ? Number(values.height) : null,
                internal_codification: values.internal_codification,
                electric_power: values.electric_power ? Number(values.electric_power) : null,
                manufacture_date: values.manufacture_date ? new Date(values.manufacture_date) : null,
                commissioning_date: values.commissioning_date ? new Date(values.commissioning_date) : null,
                Dedicated_to: values.Dedicated_to,
                model: values.model,
                type: values.type,
                serial_number: values.serial_number,
                intensity: values.intensity ? Number(values.intensity) : null,
                purchase_date: values.purchase_date ? new Date(values.purchase_date) : null,
                purchase_price: values.purchase_price ? Number(values.purchase_price) : null,
            };
            try {
                const response = await axios.patch(`machine/caracteristique/${id}`, data);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier les caractéristiques de la machine' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, ...response.data }));
                    setModifyCaracteristique(false);
                }
            } catch (error) {
                console.error('Error updating machine caracteristique:', error);
                CustomErrorLogger(error, 'Error updating machine caracteristique in machine ModifierCaracteristique');
            }
        },
    });

    const { handleSubmit, values, handleBlur, touched, errors, handleChange, setFieldValue } = formik;

    const handleChangeMarque = async (event, newValue) => {
        if (typeof newValue === 'string') {
            setFieldValue('marque', { name: newValue });
        } else if (newValue && newValue.inputValue) {
            const newOption = { name: newValue.inputValue };
            try {
                const response = await axios.post('marque', newOption);
                if (response.status === 200 || response.status === 201) {
                    setFieldValue('marque', response.data);
                    setBrandOptions((prevOptions) => [...prevOptions, response.data]);
                }
            } catch (error) {
                console.error('Error adding new brand:', error);
                CustomErrorLogger(error, 'Error adding new brand in machine ModifierCaracteristique');
            }
        } else {
            setFieldValue('marque', newValue);
        }
    };

    const getOptionLabelMarque = (option) => {
        if (typeof option === 'string') {
            return option;
        }
        if (option.inputValue) {
            return option.inputValue;
        }
        return option.name;
    };

    const filterOptionsMarque = (options, params) => {
        const filtered = options.filter((option) =>
            option.name.toLowerCase().includes(params.inputValue.toLowerCase())
        );

        if (params.inputValue !== '' && !filtered.some(option => option.name.toLowerCase() === params.inputValue.toLowerCase())) {
            filtered.push({
                inputValue: params.inputValue,
                name: `Ajouter "${params.inputValue}"`,
            });
        }

        return filtered;
    };

    return (
        <Dialog open={modifyCaracteristique} fullWidth maxWidth='md'>
            <Box onClick={() => setModifyCaracteristique(false)} className='modifierCaracteristique_icon_text'>
                <Typography className='modifierCaracteristique_title'>{t('Modifier les caractéristiques de la machine')}</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierCaracteristique_close_icon' />
            </Box>
            <form onSubmit={handleSubmit}>
                <DialogContent className='modifierCaracteristique_dialog_content'>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Marque')}</FormHelperText>
                                <Autocomplete
                                    options={brandOptions}
                                    value={values.marque}
                                    getOptionLabel={getOptionLabelMarque}
                                    onChange={handleChangeMarque}
                                    filterOptions={filterOptionsMarque}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            className={`modifierCaracteristique_autoCopleteField ${values.marque ? 'filledField' : ''}`}
                                            error={touched.marque && Boolean(errors.marque)}
                                            helperText={touched.marque && errors.marque}
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                            {...props}
                                            selected={selected}
                                            className='MachineFiltration_select_metier_item'
                                        >
                                            {option.name}
                                        </MenuItem>
                                    )}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    noOptionsText={t('No options')}
                                />
                            </Box>
                            <Box mb={3} >
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Dimensions (Lon. x Lar. x Hau.)')}</FormHelperText>
                                <Box className="modifierCaracteristique_dimensions_box">
                                    <OutlinedInput
                                        className={`modifierCaracteristique_InputField ${values.length ? 'filledField' : ''}`}
                                        id="outlined-adornment-weight"
                                        type='number'
                                        value={values.length}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="length"
                                        aria-describedby="outlined-weight-helper-text"
                                        endAdornment={!isMobile && (<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>cm</div></InputAdornment>)}
                                        error={touched.length && Boolean(errors.length)}
                                        helperText={touched.length && errors.length}
                                    />
                                    <OutlinedInput
                                        className={`modifierCaracteristique_InputField ${values.width ? 'filledField' : ''}`}
                                        id="outlined-adornment-weight"
                                        type='number'
                                        value={values.width}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="width"
                                        aria-describedby="outlined-weight-helper-text"
                                        endAdornment={!isMobile && (<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>cm</div></InputAdornment>)}
                                        error={touched.width && Boolean(errors.width)}
                                        helperText={touched.width && errors.width}
                                    />
                                    <OutlinedInput
                                        className={`modifierCaracteristique_InputField ${values.height ? 'filledField' : ''}`}
                                        id="outlined-adornment-weight"
                                        type='number'
                                        value={values.height}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="height"
                                        aria-describedby="outlined-weight-helper-text"
                                        endAdornment={!isMobile && (<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>cm</div></InputAdornment>)}
                                        error={touched.height && Boolean(errors.height)}
                                        helperText={touched.height && errors.height}
                                    />
                                </Box>
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Codification interne')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.internal_codification ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    value={values.internal_codification}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="internal_codification"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.internal_codification && Boolean(errors.internal_codification)}
                                    helperText={touched.internal_codification && errors.internal_codification}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Puissance électrique')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.electric_power ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='number'
                                    value={values.electric_power}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="electric_power"
                                    aria-describedby="outlined-weight-helper-text"
                                    endAdornment={<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>Watts</div></InputAdornment>}
                                    error={touched.electric_power && Boolean(errors.electric_power)}
                                    helperText={touched.electric_power && errors.electric_power}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Date de fabrication')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_autoCopleteField ${values.manufacture_date && values.manufacture_date !== '1970-01-01T00:00:00.000Z' ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='date'
                                    value={values.manufacture_date && values.manufacture_date !== '1970-01-01T00:00:00.000Z' ? new Date(values.manufacture_date).toISOString().split('T')[0] : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="manufacture_date"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.manufacture_date && Boolean(errors.manufacture_date)}
                                    helperText={touched.manufacture_date && errors.manufacture_date}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Date de mise en service')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_autoCopleteField ${values.commissioning_date && values.commissioning_date !== '1970-01-01T00:00:00.000Z' ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='date'
                                    value={values.commissioning_date && values.commissioning_date !== '1970-01-01T00:00:00.000Z' ? new Date(values.commissioning_date).toISOString().split('T')[0] : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="commissioning_date"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.commissioning_date && Boolean(errors.commissioning_date)}
                                    helperText={touched.commissioning_date && errors.commissioning_date}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Destinée à')}</FormHelperText>
                                <Select
                                    className={`modifierCaracteristique_select_metier ${values.Dedicated_to ? 'filledField' : ''}`}
                                    value={values.Dedicated_to}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="Dedicated_to"
                                    error={touched.Dedicated_to && Boolean(errors.Dedicated_to)}
                                    helperText={touched.Dedicated_to && errors.Dedicated_to}
                                >
                                    <MenuItem className='modifierCaracteristique_item' value='ITI'>{t('ITI')}</MenuItem>
                                    <MenuItem className='modifierCaracteristique_item' value='CFA'>{t('CFA')}</MenuItem>
                                </Select>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Modèle')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.model ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    value={values.model}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="model"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.model && Boolean(errors.model)}
                                    helperText={touched.model && errors.model}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Type de machine')}</FormHelperText>
                                <Select
                                    className={`modifierCaracteristique_select_metier ${values.type ? 'filledField' : ''}`}
                                    value={values.type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="type"
                                    error={touched.type && Boolean(errors.type)}
                                    helperText={touched.type && errors.type}
                                >
                                    <MenuItem className='modifierCaracteristique_item' value='Portative'>{t('Portative')}</MenuItem>
                                    <MenuItem className='modifierCaracteristique_item' value='Fixe'>{t('Fixe')}</MenuItem>
                                </Select>
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Numéro de série')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.serial_number ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='text'
                                    value={values.serial_number}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="serial_number"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.serial_number && Boolean(errors.serial_number)}
                                    helperText={touched.serial_number && errors.serial_number}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Intensité électrique')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.intensity ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='number'
                                    value={values.intensity}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="intensity"
                                    aria-describedby="outlined-weight-helper-text"
                                    endAdornment={<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>Ampères</div></InputAdornment>}
                                    error={touched.intensity && Boolean(errors.intensity)}
                                    helperText={touched.intensity && errors.intensity}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Date d’achat')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_autoCopleteField ${values.purchase_date && values.purchase_date !== '1970-01-01T00:00:00.000Z' ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='date'
                                    value={values.purchase_date && values.purchase_date !== '1970-01-01T00:00:00.000Z' ? new Date(values.purchase_date).toISOString().split('T')[0] : ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="purchase_date"
                                    aria-describedby="outlined-weight-helper-text"
                                    error={touched.purchase_date && Boolean(errors.purchase_date)}
                                    helperText={touched.purchase_date && errors.purchase_date}
                                />
                            </Box>
                            <Box mb={3}>
                                <FormHelperText id="outlined-weight-helper-text" className="modifierCaracteristique_helper_text">{t('Prix d’achat')}</FormHelperText>
                                <OutlinedInput
                                    className={`modifierCaracteristique_InputField ${values.purchase_price ? 'filledField' : ''}`}
                                    id="outlined-adornment-weight"
                                    type='number'
                                    value={values.purchase_price}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="purchase_price"
                                    aria-describedby="outlined-weight-helper-text"
                                    endAdornment={<InputAdornment position="end" className='modifierCaracteristique_InputAdornment'><div>€</div></InputAdornment>}
                                    error={touched.purchase_price && Boolean(errors.purchase_price)}
                                    helperText={touched.purchase_price && errors.purchase_price}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='modifierCaracteristique_dialog_actions'>
                    <Button className='modifierCaracteristique_button_annuler' onClick={() => setModifyCaracteristique(false)}>{t('Annuler')}</Button>
                    <Button className='modifierCaracteristique_button_valider' variant="contained" type='submit'>{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};